export default __webpack_public_path__ + "static/media/profile_page_bg_example.60537fb7.jpg";